var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"docScroll",attrs:{"id":"recurring_billing"}},[_c('HeaderTemplate',{attrs:{"data":_vm.contentHeader}}),_c('SectionColumn',{attrs:{"type":"full","content":_vm.contentCol}}),_c('v-col',[_c('v-divider',{staticClass:"ma-3"}),_c('Subscriptions'),_c('Tokenization'),_c('RecurringCardUpdate'),_c('RecurringExtended')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }